/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/workMenu/generalQuery/searchIndex',
    name: '/searchIndex',
    meta: {
      title: '通用查询平台',
      isYiXian: true
    },
    component: () => import(/* webpackChunkName: "searchIndex" */ '../views/workMenu/generalQuery/searchIndex.vue')
  }
]
